module.exports = require("fast-content-type-parse");